<script>
  import { afterUpdate } from "svelte"
  export let placement = {}

  export let currentpage
  export let pdfDimensions = {}

  let hideSign = true
  /**
   * @type {HTMLDivElement}
   */
  let signElement

  export let source

  afterUpdate(() => {
    if (!currentpage && currentpage == 0) return

    if (placement.pages == "ALL") hideSign = false
    else if (placement.pages == "ODD") hideSign = currentpage % 2 == 0
    else if (placement.pages == "EVEN") hideSign = currentpage % 2 != 0
    else hideSign = Number(placement.pages) != currentpage - 1

    if (hideSign) return

    let xRatio = pdfDimensions.width / pdfDimensions.clientWidth
    let yRatio = pdfDimensions.height / pdfDimensions.clientHeight

    let [x1, y1, x2, y2] = placement.coordinate.split(",").map(Number)

    let height = Math.abs(y2 - y1) / yRatio
    let x = x1 / xRatio
    let width = Math.abs(x2 - x1) / xRatio
    let y = pdfDimensions.clientHeight - height - y1 / yRatio

    signElement.style.width = width + "px"
    signElement.style.height = height + "px"
    signElement.style.left = x + "px"
    signElement.style.top = y + "px"
  })
</script>

<div bind:this={signElement} class="bottom-0 left-0 text-[0.6em] font-bold {hideSign ? 'hidden' : 'block'} absolute z-10 h-[7%] w-[30%] select-none">
  <img src={source} alt="placement{placement.id}" class="h-full w-full" />
</div>
